// Copyright (C) Microsoft Corporation. All rights reserved.

import { LoadSmbDownload } from './SmbDownload';

(<any>window).loadSmbDownload = LoadSmbDownload;
